'use client';

import { useTheme } from 'next-themes';
import { MoonIcon, SunIcon } from '@heroicons/react/20/solid';
import { NavbarItem } from '@/components/navbar';

function DarkLightMode() {
	const { theme, setTheme } = useTheme();

	return (
		<NavbarItem
			aria-label="Toggle themes"
			onClick={() => setTheme(theme === 'dark' ? 'light' : 'dark')}
		>
			<MoonIcon className="rotate-90 scale-0 transition-all dark:rotate-0 dark:scale-100" />
			<SunIcon className="absolute rotate-0 scale-100 transition-all dark:-rotate-90 dark:scale-0" />
			<span className="sr-only">Toggle theme</span>
		</NavbarItem>
	);
}

export default DarkLightMode;
